import { render, staticRenderFns } from "./Bonos.vue?vue&type=template&id=7af8c0e3"
import script from "./Bonos.vue?vue&type=script&lang=js"
export * from "./Bonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports